export enum OrderCompletedBy {
  Automation = 'closed_by_automation',
  Manually = 'closed_manually',
}
